module.exports = __webpack_public_path__ + "img/PMS_MZ.79465cb5.gif";